<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới địa bàn</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Địa bàn cha:"
                                              label-for="region"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <region-tree v-model="region.parentId"
                                                 class="col-md-6" ref="regionTree"></region-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Mã địa bàn:"
                                              label-for="code"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" id="code"
                                                  class="col-md-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.region.code.$model"
                                                  :state="($v.region.code.$dirty? !$v.region.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.region.code.$error">
                                        Vui lòng nhập mã địa bàn
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="!$v.region.code.$error && ($v.codeUnique.$error)">
                                        Mã địa bàn đã tồn tại
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Tên địa bàn:"
                                              label-for="name"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" id="name"
                                                  class="col-md-6"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.region.name.$model"
                                                  :state="($v.region.name.$dirty? !$v.region.name.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback" v-if="$v.region.name.$error">
                                        Vui lòng nhập tên địa bàn
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Đang hoạt động:"
                                              id="status"
                                              label-for="isActive"
                                              :label-cols="4" label-cols-md="2"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-checkbox id="isActive"
                                                     class="mgt-10 col-6"
                                                     v-model="region.isActive">
                                        <!--Trạng thái-->
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button v-if="authorize(['ManageRegion'])" type="submit" variant="primary">Lưu</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'CreateNation',
        mixins: [validationMixin, mixins],
        data() {
            return {
                codeUnique: 'ok',
                region: {
                    name: null,
                    code: null,
                    parentId: null
                },
            }
        },
        watch: {
            'region.parentId'(newVal) {
                var codeParent = this.$store.getters.getRegionCode(newVal);
                this.region.code = codeParent;
            },
        },
        validations: {
            region: {
                name: { required },
                code: { required },
            },
            codeUnique: { required },
        },
        created() {

        },
        methods: {
            cancel() {
                this.$router.push({ path: '.' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (vm.region.code != null && vm.region.code != '') {
                    vm.$services.get(`master-data/existing-regions-code`, { id: vm.region.id || '', code: vm.region.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";

                            if (!vm.$v.$invalid && vm.codeUnique != "") {
                                vm.$services.post('master-data/regions', vm.region).done((id) => {
                                    vm.$toastr.s('Tạo mới địa bàn thành công');
                                    vm.$store.dispatch('loadRegions').done(() => {
                                        vm.cancel();
                                    });
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                        
                    });
                }
               
            },
        }
    }
</script>
<style scoped>

    .mgt-10 {
        margin-top: 10px;
    }
</style>
